(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class RevealOnScroll extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      observer.observe(this);
    }
  }
  if (!customElements.get('reveal-on-scroll')) {
    customElements.define('reveal-on-scroll', RevealOnScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('country-select')) {
    customElements.define('country-select', class extends HTMLElement {
      connectedCallback() {
        const s = this.querySelector('select');
        if (s) s.addEventListener('change', () => s.form && s.form.submit());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class CartCount extends HTMLElement {
    connectedCallback() { this._on = () => this.refresh(); document.addEventListener('cart:updated', this._on); }
    disconnectedCallback() { document.removeEventListener('cart:updated', this._on); }
    async refresh() { try { const c = await (await fetch('/cart.js')).json(); this.textContent = c.item_count; } catch (e) {} }
  }
  if (!customElements.get('cart-count')) customElements.define('cart-count', CartCount);

  (function () {
    const header = document.querySelector('[data-header]');
    if (!header) return;
    const burger = header.querySelector('[data-burger]');
    const drawer = document.querySelector('[data-drawer]');
    const overlay = document.querySelector('[data-overlay]');
    const closeBtn = drawer && drawer.querySelector('[data-drawer-close]');
    const toggle = (open) => {
      const willOpen = open ?? drawer.hasAttribute('hidden');
      [drawer, overlay].forEach(el => { if (!el) return; if (willOpen) { el.removeAttribute('hidden'); el.classList.add('is-open'); } else { el.classList.remove('is-open'); setTimeout(() => el.setAttribute('hidden', ''), 300); } });
      burger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      document.body.style.overflow = willOpen ? 'hidden' : '';
    };
    if (burger && drawer) {
      burger.addEventListener('click', () => toggle());
      if (closeBtn) closeBtn.addEventListener('click', () => toggle(false));
      if (overlay) overlay.addEventListener('click', () => toggle(false));
      drawer.addEventListener('click', e => { if (e.target.tagName === 'A') toggle(false); });
      addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hasAttribute('hidden')) toggle(false); });
    }
    // transparent-on-home → solid on scroll
    if (header.classList.contains('header--home')) {
      const onScroll = () => header.classList.toggle('is-scrolled', scrollY > 40);
      addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    // promo rotator
    const track = header.querySelector('[data-promo]');
    if (track) {
      const items = track.querySelectorAll('.header__promo-item');
      if (items.length > 1) { let i = 0; setInterval(() => { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 4000); }
    }
    // locale select submit
    const sel = header.querySelector('[data-locale-select]');
    if (sel) sel.addEventListener('change', () => sel.form && sel.form.submit());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  class CartItems extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-change]');
        if (b) { const key = b.closest('.crow').dataset.key; this.change(key, parseInt(b.dataset.change, 10)); }
      });
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-qty-input]')) {
          const key = e.target.closest('.crow').dataset.key;
          this.change(key, Math.max(0, parseInt(e.target.value, 10) || 0));
        }
      });
      this.runOrphanCleanup();
    }
    async runOrphanCleanup() {
      if (!window.MtBundleCart || typeof window.MtBundleCart.cleanupOrphanAddons !== 'function') return;
      try {
        const result = await window.MtBundleCart.cleanupOrphanAddons();
        if (result.removedCount > 0) {
          const html = await (await fetch(location.pathname + '?section_id=' + this.section)).text();
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
          if (fresh) this.innerHTML = fresh.innerHTML;
        }
      } catch (e) {}
    }
    async change(id, quantity) {
      this.classList.add('cart-items--loading');
      try {
        if (window.MtBundleCart && typeof window.MtBundleCart.changeLine === 'function') {
          await window.MtBundleCart.changeLine(id, quantity);
        } else {
          await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: quantity }) });
        }
        const html = await (await fetch(location.pathname + '?section_id=' + this.section)).text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
        if (fresh) this.innerHTML = fresh.innerHTML;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart' } }));
      } catch (e) { location.reload(); }
      finally { this.classList.remove('cart-items--loading'); }
    }
  }
  if (!customElements.get('cart-items')) customElements.define('cart-items', CartItems);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  class FacetForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-auto-submit], input[type=checkbox], input[type=number]')) this.form.submit();
      });
    }
  }
  if (!customElements.get('facet-form')) customElements.define('facet-form', FacetForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const t = e.target.closest('[data-target]'); if (!t) return;
        this.showMedia(t.getAttribute('data-target'));
      });
    }
    showMedia(id) {
      if (!id) return;
      this.querySelectorAll('.pgallery__slide').forEach(s => s.classList.toggle('is-active', s.dataset.mediaId == id));
      this.querySelectorAll('.pgallery__thumb').forEach(b => b.classList.toggle('is-active', b.dataset.target == id));
    }
  }
  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);

  class VariantSelects extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('product-form');
      this.addEventListener('change', () => this.form && this.form.onVariantChange());
    }
    get selectedValues() { return Array.from(this.querySelectorAll('input[type=radio]:checked')).map(i => i.value); }
  }
  if (!customElements.get('variant-selects')) customElements.define('variant-selects', VariantSelects);

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.idInput = this.querySelector('[data-variant-id]');
      this.selects = this.querySelector('variant-selects');
      this.form = this.closest('form');
      this.status = this.querySelector('[data-atc-status]');
      this.btn = this.querySelector('[data-atc]');
      this.section = this.dataset.section;
      this.querySelectorAll('[data-qty]').forEach(b => b.addEventListener('click', () => this.stepQty(b.dataset.qty)));
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.querySelectorAll('[data-copy]').forEach(b => b.addEventListener('click', () => this.copyCode(b)));
    }
    copyCode(b) {
      const m = (b.dataset.copy.match(/([A-Z0-9]{4,})/) || [])[1] || b.dataset.copy;
      navigator.clipboard && navigator.clipboard.writeText(m);
      b.classList.add('is-copied'); setTimeout(() => b.classList.remove('is-copied'), 1500);
    }
    stepQty(dir) { const q = this.querySelector('.qty__input'); let v = parseInt(q.value, 10) || 1; q.value = dir === 'plus' ? v + 1 : Math.max(1, v - 1); }
    onVariantChange() {
      if (!this.selects) return;
      const vals = this.selects.selectedValues;
      const match = this.variants.find(v => JSON.stringify(v.options) === JSON.stringify(vals));
      // update each option's shown value + close the accordion
      this.querySelectorAll('.voption').forEach((d, i) => {
        const val = d.querySelector('.voption__val'); if (val && vals[i]) val.textContent = vals[i];
        d.open = false;
      });
      const priceEl = document.getElementById('price-' + this.section);
      if (!match) { this.setUnavailable(); return; }
      this.idInput.value = match.id;
      if (match.featured_media) { const g = document.querySelector('product-gallery'); if (g) g.showMedia(match.featured_media.id); }
      if (typeof match.price === 'number' && priceEl) priceEl.innerHTML = '<span class="price">' + this.formatMoney(match.price) + '</span>';
      const text = this.querySelector('[data-atc-text]');
      if (match.available) { this.btn.disabled = false; text.textContent = window.metryStrings ? window.metryStrings.add : 'Add to cart'; }
      else { this.btn.disabled = true; text.textContent = window.metryStrings ? window.metryStrings.soldout : 'Sold out'; }
    }
    setUnavailable() { this.btn.disabled = true; this.querySelector('[data-atc-text]').textContent = window.metryStrings ? window.metryStrings.unavailable : 'Unavailable'; }
    formatMoney(cents) { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$' + (cents / 100).toFixed(2); }
    async onSubmit(e) {
      e.preventDefault(); this.btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: this.idInput.value, quantity: parseInt(this.querySelector('.qty__input').value, 10) || 1 }) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product' } }));
        this.showStatus(window.metryStrings ? window.metryStrings.added : 'Added to cart', false);
      } catch (err) { this.showStatus(err.message, true); } finally { this.btn.disabled = false; }
    }
    showStatus(msg, isError) { if (!this.status) return; this.status.textContent = msg; this.status.hidden = false; this.status.classList.toggle('is-error', !!isError); }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-compare"] && !Shopify.designMode) return;
  try {
    

  class MtCompare extends HTMLElement {

    connectedCallback() {

      if (this._ready) return;

      this._ready = true;

      this.scrollEl =
        this.querySelector('.mt-compare__scroll');

      if (!this.scrollEl) return;

      this._onScroll = () => {

        this.classList.toggle(
          'is-scrolled-x',
          this.scrollEl.scrollLeft > 4
        );

      };

      this.scrollEl.addEventListener(
        'scroll',
        this._onScroll,
        { passive: true }
      );

      this._onScroll();

    }

    disconnectedCallback() {

      if (
        this.scrollEl &&
        this._onScroll
      ) {

        this.scrollEl.removeEventListener(
          'scroll',
          this._onScroll
        );

      }

    }

  }

  if (!customElements.get('mt-compare')) {

    customElements.define(
      'mt-compare',
      MtCompare
    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-court-surfaces"] && !Shopify.designMode) return;
  try {
    
  class MtCourtSurfaces extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.scrollEl = this.querySelector('.mt-court-surfaces__scroll');
      this.addEventListener('click', (event) => this.handleClick(event));
      if (this.scrollEl) {
        this._onCarouselScroll = this.handleCarouselScroll.bind(this);
        this.scrollEl.addEventListener('scroll', this._onCarouselScroll, { passive: true });
      }
    }

    disconnectedCallback() {
      if (this.scrollEl && this._onCarouselScroll) {
        this.scrollEl.removeEventListener('scroll', this._onCarouselScroll);
      }
    }

    isMobileCarousel() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    collapseCards() {
      this.querySelectorAll('[data-court-card]').forEach(function (item) {
        item.classList.remove('is-expanded');
        var toggle = item.querySelector('[data-court-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }

    handleCarouselScroll() {
      if (!this.isMobileCarousel() || this._scrollCollapseTimer) return;
      this._scrollCollapseTimer = window.requestAnimationFrame(() => {
        this._scrollCollapseTimer = null;
        if (this.querySelector('.is-expanded')) this.collapseCards();
      });
    }

    handleClick(event) {
      var button = event.target.closest('[data-court-toggle]');
      if (!button || !this.contains(button)) return;

      var card = button.closest('[data-court-card]');
      var cards = Array.from(this.querySelectorAll('[data-court-card]'));
      var shouldExpand = !card.classList.contains('is-expanded');

      cards.forEach(function (item) {
        item.classList.remove('is-expanded');
        item.querySelector('[data-court-toggle]').setAttribute('aria-expanded', 'false');
      });

      if (shouldExpand) {
        card.classList.add('is-expanded');
        button.setAttribute('aria-expanded', 'true');
      }
    }
  }

  if (!customElements.get('mt-court-surfaces')) {
    customElements.define('mt-court-surfaces', MtCourtSurfaces);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-dual-media"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-dual-media')) {
    customElements.define(
      'mt-dual-media',
      class extends HTMLElement {
        connectedCallback() {
          this._videoIo = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                var video = entry.target;
                var item = video.closest('.mt-dual-media__item');
                if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
                  this.loadVideo(video);
                  var playPromise = video.play();
                  if (playPromise && playPromise.then) {
                    playPromise
                      .then(function () {
                        if (item) item.classList.add('is-playing');
                      })
                      .catch(function () {});
                  } else if (item) {
                    item.classList.add('is-playing');
                  }
                } else {
                  video.pause();
                  if (item) item.classList.remove('is-playing');
                }
              });
            },
            { threshold: [0, 0.45, 0.75] }
          );

          this.querySelectorAll('[data-dual-video]').forEach((video) => {
            this._videoIo.observe(video);
          });
        }

        disconnectedCallback() {
          if (this._videoIo) this._videoIo.disconnect();
        }

        loadVideo(video) {
          video.querySelectorAll('source[data-src]').forEach(function (source) {
            if (!source.src) source.src = source.getAttribute('data-src');
          });
          if (video.readyState < 2) video.load();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-faq"] && !Shopify.designMode) return;
  try {
    
  class MtFaq extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.tabs = Array.from(this.querySelectorAll('[data-faq-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-faq-panel]'));
      this._tabIndex = 0;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          var i = parseInt(tab.getAttribute('data-index'), 10) || 0;
          this.activateTab(i);
          if (window.matchMedia('(max-width: 989px)').matches) {
            tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        });
      });

      this.querySelectorAll('[data-faq-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => this.toggleItem(trigger));
      });

      if (this.panels.length) this.activateTab(0);
    }

    activateTab(index) {
      if (!this.panels.length) return;
      var len = this.panels.length;
      this._tabIndex = ((index % len) + len) % len;

      this.panels.forEach((panel, n) => {
        var on = n === this._tabIndex;
        panel.classList.toggle('is-active', on);
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });

      this.tabs.forEach((tab) => {
        var i = parseInt(tab.getAttribute('data-index'), 10) || 0;
        var on = i === this._tabIndex;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    toggleItem(activeTrigger) {
      var item = activeTrigger.closest('.mt-faq__item');
      var panel = document.getElementById(activeTrigger.getAttribute('aria-controls'));
      if (!item || !panel) return;

      var panelRoot = activeTrigger.closest('[data-faq-panel]');
      var shouldOpen = !item.classList.contains('is-open');

      if (panelRoot) {
        panelRoot.querySelectorAll('.mt-faq__item').forEach((entry) => {
          var trigger = entry.querySelector('[data-faq-trigger]');
          var answer = trigger ? document.getElementById(trigger.getAttribute('aria-controls')) : null;
          var open = entry === item && shouldOpen;
          entry.classList.toggle('is-open', open);
          if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (answer) {
            if (open) answer.removeAttribute('hidden');
            else answer.setAttribute('hidden', '');
          }
        });
      }
    }
  }

  if (!customElements.get('mt-faq')) customElements.define('mt-faq', MtFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-gallery-columns"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-gallery-columns')) {
    customElements.define('mt-gallery-columns', class extends HTMLElement {
      connectedCallback() {
        this.syncAutoplay();
        this.bindVideos();
        this._motionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._onMotion = () => this.syncAutoplay();
        if (this._motionMq.addEventListener) {
          this._motionMq.addEventListener('change', this._onMotion);
        } else if (this._motionMq.addListener) {
          this._motionMq.addListener(this._onMotion);
        }
      }

      disconnectedCallback() {
        if (this._motionMq && this._onMotion) {
          if (this._motionMq.removeEventListener) {
            this._motionMq.removeEventListener('change', this._onMotion);
          } else if (this._motionMq.removeListener) {
            this._motionMq.removeListener(this._onMotion);
          }
        }
      }

      bindVideos() {
        var root = this;
        this.dialog = this.querySelector('[data-gallery-dialog]');
        this.dialogVideo = this.querySelector('[data-gallery-dialog-video]');
        this.dialogClose = this.querySelector('[data-gallery-dialog-close]');

        if (this.dialog && !this.dialog._gcBound) {
          this.dialog._gcBound = true;
          if (this.dialogClose) {
            this.dialogClose.addEventListener('click', function () {
              root.closeVideoDialog();
            });
          }
          this.dialog.addEventListener('click', function (event) {
            if (event.target === root.dialog) root.closeVideoDialog();
          });
          this.dialog.addEventListener('close', function () {
            root.resetDialogVideo();
          });
        }

        this.querySelectorAll('[data-gallery-open]').forEach(function (trigger) {
          if (trigger._gcBound) return;
          trigger._gcBound = true;
          trigger.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            root.openVideoDialog(trigger);
          });
        });
      }

      resetDialogVideo() {
        var video = this.dialogVideo;
        if (!video) return;
        video.pause();
        video.removeAttribute('poster');
        video.innerHTML = '';
      }

      closeVideoDialog() {
        if (this.dialog && this.dialog.open) this.dialog.close();
      }

      openVideoDialog(trigger) {
        var dialog = this.dialog;
        var video = this.dialogVideo;
        if (!trigger || !dialog || !video) return;

        var sourcesRaw = trigger.getAttribute('data-video-sources');
        if (!sourcesRaw) return;

        var sources;
        try {
          sources = JSON.parse(sourcesRaw);
        } catch (error) {
          return;
        }
        if (!sources || !sources.length) return;

        this.resetDialogVideo();

        sources.forEach(function (source) {
          if (!source || !source.url) return;
          var el = document.createElement('source');
          el.src = source.url;
          el.type = source.type || 'video/mp4';
          video.appendChild(el);
        });

        var poster = trigger.getAttribute('data-video-poster');
        if (poster) video.setAttribute('poster', poster);

        video.load();
        dialog.showModal();

        var start = function () {
          var playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        };

        if (video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
          start();
        } else {
          video.addEventListener('canplay', start, { once: true });
        }
      }

      syncAutoplay() {
        var allow = this.dataset.autoplay === 'true'
          && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.classList.toggle('is-autoplay', allow);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-help-faq"] && !Shopify.designMode) return;
  try {
    
  class MtHelpFaq extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.querySelectorAll('.mt-help-faq__trigger').forEach((trigger) => {
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        panel.hidden = false;
        trigger.addEventListener('click', () => this.openItem(trigger));
      });
    }

    openItem(activeTrigger) {
      this.querySelectorAll('.mt-help-faq__trigger').forEach((trigger) => {
        const item = trigger.closest('.mt-help-faq__item');
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        const shouldOpen = trigger === activeTrigger;

        trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        panel.hidden = false;
        item.classList.toggle('is-open', shouldOpen);
      });
    }
  }

  if (!customElements.get('mt-help-faq')) {
    customElements.define('mt-help-faq', MtHelpFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-help-search"] && !Shopify.designMode) return;
  try {
    
  class MtHelpSearch extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      var input = this.querySelector('input[type="search"]');
      if (!input) return;

      this.querySelectorAll('.mt-help-search__chip[type="submit"]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          input.value = chip.value;
        });
      });
    }
  }

  if (!customElements.get('mt-help-search')) {
    customElements.define('mt-help-search', MtHelpSearch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-help-video-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-help-videos')) {
    customElements.define('mt-help-videos', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.tabs = this.querySelectorAll('.mt-help-videos__tab[data-tab]');
        this.items = this.querySelectorAll('[data-video-item]');
        this._mq = window.matchMedia('(max-width: 749px)');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.tab, tab));
        });

        this.querySelectorAll('[data-video-toggle]').forEach((media) => this.bindMedia(media));

        this._onMq = () => this.pauseAll();
        if (this._mq.addEventListener) this._mq.addEventListener('change', this._onMq);
        else this._mq.addListener(this._onMq);
      }

      disconnectedCallback() {
        if (!this._mq || !this._onMq) return;
        if (this._mq.removeEventListener) this._mq.removeEventListener('change', this._onMq);
        else this._mq.removeListener(this._onMq);
      }

      bindMedia(media) {
        media.addEventListener('click', (event) => {
          if (event.target.closest('[data-video-progress]')) return;
          this.toggleVideo(media);
        });

        media.querySelectorAll('[data-gallery-video]').forEach((video) => {
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.controls = false;
          video.addEventListener('timeupdate', () => this.syncProgress(media, video));
          video.addEventListener('loadedmetadata', () => this.syncProgress(media, video));
          video.addEventListener('play', () => media.classList.add('is-playing', 'is-started'));
          video.addEventListener('pause', () => media.classList.remove('is-playing'));
          video.addEventListener('ended', () => {
            media.classList.remove('is-playing', 'is-started');
            video.currentTime = 0;
            this.syncProgress(media, video);
          });
        });

        const track = media.querySelector('[data-video-progress]');
        if (!track) return;

        const seekFromEvent = (event) => {
          const video = this.visibleVideo(media);
          if (!video || !video.duration) return;
          const point = event.touches && event.touches[0] ? event.touches[0] : event;
          const rect = track.getBoundingClientRect();
          const ratio = Math.min(1, Math.max(0, (point.clientX - rect.left) / rect.width));
          video.currentTime = ratio * video.duration;
          this.syncProgress(media, video);
        };

        track.addEventListener('pointerdown', (event) => {
          event.preventDefault();
          event.stopPropagation();
          track.setPointerCapture(event.pointerId);
          seekFromEvent(event);
        });
        track.addEventListener('pointermove', (event) => {
          if (!track.hasPointerCapture(event.pointerId)) return;
          event.preventDefault();
          seekFromEvent(event);
        });
        track.addEventListener('pointerup', (event) => event.stopPropagation());
        track.addEventListener('click', (event) => event.stopPropagation());
      }

      syncProgress(media, video) {
        if (video !== this.visibleVideo(media)) return;
        const fill = media.querySelector('[data-video-progress-fill]');
        if (!fill) return;
        const duration = video.duration;
        const pct = duration && isFinite(duration) ? (video.currentTime / duration) * 100 : 0;
        fill.style.width = pct + '%';
      }

      activate(handle, button) {
        this.tabs.forEach((tab) => {
          const active = tab === button;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        this.items.forEach((item) => {
          const itemTab = item.dataset.tab || '';
          item.hidden = !!(itemTab && itemTab !== handle);
        });

        this.pauseAll();
      }

      visibleVideo(media) {
        const desktop = media.querySelector('.mt-help-videos__frame--desktop [data-gallery-video]');
        const mobile = media.querySelector('.mt-help-videos__frame--mobile [data-gallery-video]');
        return this._mq.matches ? (mobile || desktop) : (desktop || mobile);
      }

      pauseAll(except) {
        this.querySelectorAll('[data-gallery-video]').forEach((video) => {
          if (video === except) return;
          video.pause();
          const media = video.closest('[data-video-toggle]');
          if (media) media.classList.remove('is-playing');
        });
      }

      toggleVideo(media) {
        const video = this.visibleVideo(media);
        if (!video) return;
        if (video.paused) {
          this.pauseAll(video);
          const playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        } else {
          video.pause();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-lp-app"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-lp-app')) {
    customElements.define('mt-lp-app', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-lp-tab]'));
        this.panel = this.querySelector('[role="tabpanel"]');
        this.court = this.querySelector('[data-lp-court]');
        this.list = this.querySelector('.lp-app__tabs');        this.current = 0;
        if (this.list) {
          this.list.addEventListener('scroll', () => {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => this.syncFromScroll(), 140);
          }, { passive: true });
        }
        this.addEventListener('shopify:block:select', (e) => {
          var i = this.tabs.indexOf(e.target);
          if (i > -1) this.select(i, true);
        });
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, true));
          tab.addEventListener('keydown', (e) => {
            var next = i;
            if (e.key === 'Home') next = 0;
            else if (e.key === 'End') next = this.tabs.length - 1;
            else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
            else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
            else return;
            e.preventDefault();
            this.tabs[next].focus({ preventScroll: true });
            this.select(next, true);
          });
        });

        var play = this.querySelector('[data-lp-play]');
        if (play) {
          play.addEventListener('click', () => {
            var on = play.getAttribute('aria-pressed') !== 'true';
            play.setAttribute('aria-pressed', String(on));
            this.court.classList.toggle('is-playing', on);
            play.querySelector('[data-lp-play-on]').hidden = on;
            play.querySelector('[data-lp-play-off]').hidden = !on;
            play.querySelector('[data-lp-play-icon]').innerHTML = on ? '&#10074;&#10074;' : '&#9654;';
          });
        }
        if (this.tabs.length) this.select(0);
      }

      isScrollable() {
        return this.list && this.list.scrollWidth > this.list.clientWidth + 1;
      }

      scrollToTab(tab) {
        if (!this.isScrollable()) return;
        var pad = parseFloat(getComputedStyle(this.list).paddingLeft) || 0;
        this.list.scrollTo({ left: tab.offsetLeft - pad, behavior: 'smooth' });
      }

      syncFromScroll() {
        if (!this.isScrollable()) return;
        var pad = parseFloat(getComputedStyle(this.list).paddingLeft) || 0;
        var left = this.list.scrollLeft;
        var nearest = 0;
        if (left >= this.list.scrollWidth - this.list.clientWidth - 2) {
          nearest = this.tabs.length - 1;
        } else {
          var best = Infinity;
          this.tabs.forEach((t, n) => {
            var d = Math.abs(t.offsetLeft - pad - left);
            if (d < best) { best = d; nearest = n; }
          });
        }
        if (nearest !== this.current) this.select(nearest, false);
      }

      select(index, scroll) {
        var tab = this.tabs[index];
        if (!tab) return;
        this.current = index;        if (scroll) this.scrollToTab(tab);
        this.tabs.forEach((t) => {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
        });
        this.panel.setAttribute('aria-labelledby', tab.id);
        this.querySelectorAll('[data-step]').forEach((el) => { el.hidden = el.dataset.step !== String(index); });

        var ball = (tab.dataset.ball || '').split(',');
        var zone = (tab.dataset.zone || '').split(',');
        var path = this.querySelector('[data-lp-path]');
        var ballEl = this.querySelector('[data-lp-ball]');
        var zoneEl = this.querySelector('[data-lp-zone]');
        if (path) path.setAttribute('d', tab.dataset.path);
        if (ballEl && ball.length === 2) { ballEl.setAttribute('cx', ball[0]); ballEl.setAttribute('cy', ball[1]); }
        if (zoneEl && zone.length === 2) { zoneEl.setAttribute('x', zone[0]); zoneEl.setAttribute('y', zone[1]); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-lp-bundle-picker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-lp-bundle-picker')) {
    customElements.define('mt-lp-bundle-picker', class extends HTMLElement {
      connectedCallback() {
        this.tiles = Array.from(this.querySelectorAll('[data-lp-bp-tile]'));
        this.images = Array.from(this.querySelectorAll('[data-lp-bp-img]'));
        this.idInput = this.querySelector('[data-lp-bp-id]');
        this.btn = this.querySelector('[data-lp-bp-atc]');
        this.btnText = this.querySelector('[data-lp-bp-atc-text]');
        this.tiles.forEach((tile, i) => tile.addEventListener('click', () => this.select(i)));
        this.addEventListener('shopify:block:select', (e) => {
          var i = this.tiles.indexOf(e.target);
          if (i > -1) this.select(i);
        });
        if (this.btn) this.btn.addEventListener('click', () => this.addToCart());
      }

      money(cents) {
        var format = (this.dataset.moneyFormat || '').replace(/<[^>]*>/g, '');
        var value = cents / 100;
        if (!format) return '$' + value.toFixed(2);
        var fixed = function (n, d, t, dec) {
          var parts = n.toFixed(d).split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
          return parts.length > 1 ? parts[0] + dec + parts[1] : parts[0];
        };
        var out = format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
          switch (key) {
            case 'amount_no_decimals': return fixed(value, 0, ',', '.');
            case 'amount_with_comma_separator': return fixed(value, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator': return fixed(value, 0, '.', ',');
            case 'amount_with_apostrophe_separator': return fixed(value, 2, "'", '.');
            default: return fixed(value, 2, ',', '.');
          }
        });
        return out.replace(/[.,]00(?!\d)/, '');
      }

      select(index) {
        var tile = this.tiles[index];
        if (!tile) return;
        this.tiles.forEach((t) => t.setAttribute('aria-pressed', String(t === tile)));
        this.images.forEach((img) => { img.hidden = img.dataset.lpBpImg !== String(index); });

        var price = this.querySelector('[data-lp-bp-price]');
        var compare = this.querySelector('[data-lp-bp-compare]');
        if (!tile.dataset.id) {
          this.setButton(false, this.dataset.soldOut);
          return;
        }
        var p = Number(tile.dataset.price);
        var c = Number(tile.dataset.compare);
        if (price) price.textContent = this.money(p);
        if (compare) { compare.hidden = !(c > p); compare.textContent = c > p ? this.money(c) : ''; }
        if (this.idInput) this.idInput.value = tile.dataset.id;
        var available = tile.dataset.available === 'true';
        this.setButton(available, available ? this.dataset.atc : this.dataset.soldOut);
      }

      setButton(enabled, label) {
        if (!this.btn) return;
        this.btn.disabled = !enabled;
        if (this.btnText) this.btnText.textContent = label;
      }

      status(msg, error) {
        var el = this.querySelector('[data-lp-bp-status]');
        if (!el) return;
        el.textContent = msg;
        el.hidden = !msg;
        el.classList.toggle('is-error', !!error);
      }

      async addToCart() {
        if (!this.idInput || !this.idInput.value || this.btn.disabled) return;
        this.btn.classList.add('is-loading');
        this.status('');
        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(this.idInput.value), quantity: 1 })
          });
          var data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Error');
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'rec-product', cartAdd: data } }));
          if (!document.querySelector('cart-drawer')) window.location.href = '/cart';
        } catch (err) {
          this.status(err.message, true);
        } finally {
          this.btn.classList.remove('is-loading');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-lp-models"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-lp-models')) {
    customElements.define('mt-lp-models', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-lp-tab]'));
        this.panels = Array.from(this.querySelectorAll('.lp-model'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            var next = i;
            if (e.key === 'Home') next = 0;
            else if (e.key === 'End') next = this.tabs.length - 1;
            else if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
            else if (e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
            else return;
            e.preventDefault();
            this.tabs[next].focus();
            this.select(next);
          });
        });
        this.addEventListener('shopify:block:select', (e) => {
          var i = this.tabs.indexOf(e.target);
          if (i > -1) this.select(i);
        });
      }
      select(index) {
        this.tabs.forEach((t, n) => {
          var on = n === index;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
        });
        this.panels.forEach((p, n) => { p.hidden = n !== index; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-lp-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-lp-nav')) {
    customElements.define('mt-lp-nav', class extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-lp-nav-toggle]');
        this.links = this.querySelector('.lp-nav-links');
        if (!this.toggle || !this.links) return;
        this.toggle.addEventListener('click', () => this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true'));
        this.querySelectorAll('[data-lp-nav-link]').forEach((a) => a.addEventListener('click', () => this.setOpen(false)));
        this.market = this.querySelector('[data-lp-market]');
        var back = this.querySelector('[data-lp-market-back]');
        if (back) back.addEventListener('click', () => { this.market.open = false; });
        this.onKey = (e) => {
          if (e.key === 'Escape' && this.toggle.getAttribute('aria-expanded') === 'true') {
            this.setOpen(false);
            this.toggle.focus();
          }
        };
        document.addEventListener('keydown', this.onKey);
      }
      disconnectedCallback() {
        if (this.onKey) document.removeEventListener('keydown', this.onKey);
      }
      setOpen(open) {
        this.toggle.setAttribute('aria-expanded', String(open));
        this.links.classList.toggle('is-open', open);
        if (!open && this.market) this.market.open = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-lp-plan"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-lp-plan')) {
    customElements.define('mt-lp-plan', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-lp-tab]'));
        this.panel = this.querySelector('[role="tabpanel"]');
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            var next = i;
            if (e.key === 'Home') next = 0;
            else if (e.key === 'End') next = this.tabs.length - 1;
            else if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
            else if (e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
            else return;
            e.preventDefault();
            this.tabs[next].focus();
            this.select(next);
          });
        });
        this.addEventListener('shopify:block:select', (e) => {
          var i = this.tabs.indexOf(e.target);
          if (i > -1) this.select(i);
        });
        var download = this.querySelector('[data-lp-download]');
        if (download) download.addEventListener('click', () => this.download());
      }

      select(index) {
        var tab = this.tabs[index];
        if (!tab) return;
        this.tabs.forEach((t) => {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
        });
        if (this.panel) this.panel.setAttribute('aria-labelledby', tab.id);
        this.querySelectorAll('[data-step]').forEach((el) => { el.hidden = el.dataset.step !== String(index); });
      }

      textOf(node) {
        if (!node) return '';
        var html = node.innerHTML.replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|li|h\d)>/gi, '\n');
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent.replace(/\n{3,}/g, '\n\n').trim();
      }

      download() {
        var lines = [];
        var header = this.textOf(this.querySelector('[data-lp-download-header]'));
        if (header) lines.push(header, '');
        this.querySelectorAll('[data-lp-export]').forEach((week) => {
          week.querySelectorAll('[data-lp-line]').forEach((el) => lines.push(this.textOf(el)));
          lines.push('');
        });
        var footer = this.textOf(this.querySelector('[data-lp-download-footer]'));
        if (footer) lines.push(footer);

        var blob = new Blob([lines.join('\r\n')], { type: 'text/plain;charset=utf-8' });
        var url = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = this.dataset.filename || 'practice-outline.txt';
        document.body.append(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 10000);

        var toast = this.querySelector('[data-lp-toast]');
        if (toast && toast.textContent.trim()) {
          clearTimeout(this.toastTimer);
          toast.hidden = false;
          this.toastTimer = setTimeout(() => { toast.hidden = true; }, 3500);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-lp-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-lp-product')) {
    customElements.define('mt-lp-product', class extends HTMLElement {
      connectedCallback() {
        var json = this.querySelector('[data-lp-variants]');
        this.variants = json ? JSON.parse(json.textContent) : [];
        this.idInput = this.querySelector('[data-lp-variant-id]');
        this.btn = this.querySelector('[data-lp-atc]');
        this.btnText = this.querySelector('[data-lp-atc-text]');
        this.atcLabel = this.btnText ? this.btnText.textContent : '';
        this.inputs = Array.from(this.querySelectorAll('[data-lp-option]'));
        this.inputs.forEach((input) => input.addEventListener('change', () => this.onChange()));
        if (this.btn) this.btn.addEventListener('click', () => this.addToCart());
        if (this.variants.length) this.markAvailability();
      }

      selected() {
        var values = [];
        this.inputs.forEach((input) => { if (input.checked) values[+input.dataset.lpOption] = input.value; });
        return values;
      }

      findVariant(values) {
        return this.variants.find((v) => v.options.every((o, i) => o === values[i]));
      }

      markAvailability() {
        var values = this.selected();
        this.inputs.forEach((input) => {
          var i = +input.dataset.lpOption;
          var test = values.slice();
          test[i] = input.value;
          var match = this.variants.find((v) => v.options.every((o, n) => o === test[n]));
          input.parentElement.classList.toggle('is-unavailable', !match || !match.available);
        });
      }

      money(cents) {
        var format = (this.dataset.moneyFormat || '').replace(/<[^>]*>/g, '');
        var value = cents / 100;
        if (!format) return '$' + value.toFixed(2);
        var fixed = function (n, d, t, dec) {
          var parts = n.toFixed(d).split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
          return parts.length > 1 ? parts[0] + dec + parts[1] : parts[0];
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
          switch (key) {
            case 'amount_no_decimals': return fixed(value, 0, ',', '.');
            case 'amount_with_comma_separator': return fixed(value, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator': return fixed(value, 0, '.', ',');
            case 'amount_with_apostrophe_separator': return fixed(value, 2, "'", '.');
            default: return fixed(value, 2, ',', '.');
          }
        });
      }

      onChange() {
        var v = this.findVariant(this.selected());
        this.markAvailability();
        this.current = v;
        var price = this.querySelector('[data-lp-price]');
        var compare = this.querySelector('[data-lp-compare]');
        var save = this.querySelector('[data-lp-save]');
        var img = this.querySelector('[data-lp-img] img');

        if (!v) {
          this.setButton(false, this.dataset.unavailable);
          if (compare) compare.hidden = true;
          if (save) save.hidden = true;
          return;
        }
        if (this.idInput) this.idInput.value = v.id;
        if (price) price.textContent = this.money(v.price);
        var onSale = v.compare > v.price;
        if (compare) { compare.hidden = !onSale; compare.textContent = onSale ? this.money(v.compare) : ''; }
        if (save) {
          save.hidden = !onSale;
          if (onSale) save.textContent = (this.dataset.savePrefix + ' ' + this.money(v.compare - v.price).replace(/[.,]00(?!\d)/, '')).trim();
        }
        if (img && v.image) { img.removeAttribute('srcset'); img.src = v.image; }
        this.setButton(v.available, v.available ? this.atcLabel : this.dataset.soldOut);
      }

      setButton(enabled, label) {
        if (!this.btn) return;
        this.btn.disabled = !enabled;
        if (this.btnText) this.btnText.textContent = label;
      }

      status(msg, error) {
        var el = this.querySelector('[data-lp-status]');
        if (!el) return;
        el.textContent = msg;
        el.hidden = !msg;
        el.classList.toggle('is-error', !!error);
      }

      async addToCart() {
        if (!this.idInput || this.btn.disabled) return;
        this.btn.classList.add('is-loading');
        this.status('');
        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(this.idInput.value), quantity: 1 })
          });
          var data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Error');
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'rec-product', cartAdd: data } }));
          if (!document.querySelector('cart-drawer')) window.location.href = '/cart';
        } catch (err) {
          this.status(err.message, true);
        } finally {
          this.btn.classList.remove('is-loading');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-lp-sticky"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-lp-sticky')) {
    customElements.define('mt-lp-sticky', class extends HTMLElement {
      connectedCallback() {
        var selector = this.dataset.trigger || '.lp-hero';
        var target = null;
        try { target = document.querySelector(selector); } catch (e) {}
        if (target && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.classList.toggle('is-visible', !entries[0].isIntersecting);
          });
          this.observer.observe(target);
        } else {
          this.onScroll = () => this.classList.toggle('is-visible', window.scrollY > 600);
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        }
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-lp-value"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-lp-calc')) {
    customElements.define('mt-lp-calc', class extends HTMLElement {
      connectedCallback() {
        this.machine = this.querySelector('[data-lp-machine]');
        this.lesson = this.querySelector('[data-lp-lesson]');
        if (!this.machine || !this.lesson) return;
        var locale = this.dataset.locale || 'en-US';
        var currency = this.dataset.currency || 'USD';
        try {
          this.moneyFmt = new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
        } catch (e) {
          this.moneyFmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });
        }
        this.numFmt = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        this.min = parseInt(this.dataset.min, 10) || 1;
        this.max = parseInt(this.dataset.max, 10) || 14;
        this.sessions = Math.min(this.max, Math.max(this.min, parseInt(this.dataset.sessions, 10) || 3));

        this.querySelectorAll('[data-lp-model]').forEach((btn) => {
          btn.addEventListener('click', () => this.selectModel(btn));
        });
        this.machine.addEventListener('input', () => this.update());
        this.lesson.addEventListener('input', () => this.update());
        this.querySelector('[data-lp-minus]').addEventListener('click', () => { this.sessions = Math.max(this.min, this.sessions - 1); this.update(); });
        this.querySelector('[data-lp-plus]').addEventListener('click', () => { this.sessions = Math.min(this.max, this.sessions + 1); this.update(); });
        this.update();
      }

      selectModel(btn) {
        this.machine.value = String(Number(btn.dataset.price));
        var name = this.querySelector('[data-lp-model-name]');
        var label = btn.querySelector('[data-lp-model-label]');
        if (name && label) name.textContent = '/ ' + label.textContent.trim();
        this.querySelectorAll('[data-lp-model]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        this.update();
      }

      valid(input) {
        var v = Number(input.value);
        var ok = input.value.trim() !== '' && Number.isFinite(v) && v > 0 && v <= 100000;
        input.setAttribute('aria-invalid', String(!ok));
        return ok;
      }

      update() {
        var error = this.querySelector('[data-lp-error]');
        var equivalent = this.querySelector('[data-lp-equivalent]');
        var cost = this.querySelector('[data-lp-cost]');
        var count = this.sessions * 52;
        this.querySelector('[data-lp-sessions]').value = String(this.sessions);
        this.querySelectorAll('[data-lp-count]').forEach((el) => { el.textContent = String(count); });
        this.querySelector('[data-lp-minus]').disabled = this.sessions <= this.min;
        this.querySelector('[data-lp-plus]').disabled = this.sessions >= this.max;

        var okMachine = this.valid(this.machine);
        var okLesson = this.valid(this.lesson);
        if (!okMachine || !okLesson) {
          if (error) error.hidden = false;
          equivalent.value = '\u2014';
          cost.textContent = '\u2014';
          return;
        }
        if (error) error.hidden = true;
        var machine = Number(this.machine.value);
        equivalent.value = this.numFmt.format(machine / Number(this.lesson.value));
        cost.textContent = this.moneyFmt.format(machine / count);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-policy-tabs"] && !Shopify.designMode) return;
  try {
    
  class MtPolicyTabs extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._refresh = this.refresh.bind(this);
      this._hashChange = this.handleHashChange.bind(this);
      this._sectionChange = this.scheduleRefresh.bind(this);
      window.addEventListener('hashchange', this._hashChange);
      document.addEventListener('shopify:section:load', this._sectionChange);
      document.addEventListener('shopify:section:reorder', this._sectionChange);
      this.refresh();
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this._hashChange);
      document.removeEventListener('shopify:section:load', this._sectionChange);
      document.removeEventListener('shopify:section:reorder', this._sectionChange);
      if (this._tabRo) {
        this._tabRo.disconnect();
        this._tabRo = null;
      }
    }

    scheduleRefresh() {
      window.requestAnimationFrame(this._refresh);
    }

    getPanels() {
      return Array.from(document.querySelectorAll('mt-policy-page[data-policy-name][data-policy-id]'));
    }

    refresh() {
      this.panels = this.getPanels();
      if (!this.panels.length) return;

      if (this.nav && this.nav.parentElement) {
        this.nav.parentElement.removeChild(this.nav);
      }

      this.panels.forEach(function (panel) {
        panel.id = panel.dataset.policyId;
        panel.setAttribute('role', 'tabpanel');
        var slot = panel.querySelector('.mt-policy__nav-slot');
        if (slot) slot.replaceChildren();
      });

      if (!this.nav) this.nav = this.createNavigation();
      this.tablist = this.nav.querySelector('.mt-policy__tabs');

      var hashId = decodeURIComponent(window.location.hash.slice(1));
      var requested = this.panels.find(function (panel) {
        return panel.dataset.policyId === hashId;
      });
      var current = requested || this.panels.find(function (panel) { return !panel.hidden; }) || this.panels[0];
      this.activate(current.dataset.policyId, false, false);
      this.observeTablist();
    }

    getTabs() {
      return this.tablist ? Array.from(this.tablist.querySelectorAll('[role="tab"]')) : [];
    }

    mountNav(panel) {
      if (!this.nav || !panel) return;
      var slot = panel.querySelector('.mt-policy__nav-slot');
      if (slot && this.nav.parentElement !== slot) slot.appendChild(this.nav);
    }

    updateTabPill() {
      var tablist = this.tablist;
      if (!tablist) return;
      var pill = tablist.querySelector('.mt-policy__tab-pill');
      var active = tablist.querySelector('[role="tab"][aria-selected="true"]');
      if (!pill) return;

      if (!active) {
        pill.style.height = '0';
        pill.style.width = '0';
        return;
      }

      var isHorizontal = window.matchMedia('(max-width: 749px)').matches;

      var move = function () {
        var listRect = tablist.getBoundingClientRect();
        var rect = active.getBoundingClientRect();

        if (isHorizontal) {
          pill.style.width = rect.width + 'px';
          pill.style.height = '';
          pill.style.transform = 'translateX(' + (rect.left - listRect.left) + 'px)';
        } else {
          pill.style.width = '';
          pill.style.height = rect.height + 'px';
          pill.style.transform = 'translateY(' + (rect.top - listRect.top) + 'px)';
        }
      };

      move();
      window.requestAnimationFrame(move);
    }

    observeTablist() {
      var self = this;
      if (this._tabRo) {
        this._tabRo.disconnect();
        this._tabRo = null;
      }

      if (!this.tablist || typeof ResizeObserver === 'undefined') return;

      this._tabRo = new ResizeObserver(function () {
        self.updateTabPill();
      });
      this._tabRo.observe(this.tablist);
    }

    createNavigation() {
      var nav = document.createElement('nav');
      nav.className = 'mt-policy__nav';
      nav.setAttribute('aria-label', 'Policy pages');
      var tablist = document.createElement('div');
      tablist.className = 'mt-policy__tabs';
      tablist.id = 'PolicyTabs';
      tablist.setAttribute('role', 'tablist');
      tablist.addEventListener('click', this.handleClick.bind(this));
      tablist.addEventListener('keydown', this.handleKeydown.bind(this));

      var pill = document.createElement('span');
      pill.className = 'mt-policy__tab-pill';
      pill.setAttribute('aria-hidden', 'true');
      tablist.appendChild(pill);

      this.panels.forEach(function (panel) {
        var tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'mt-policy__tab';
        tab.id = 'PolicyTab-' + panel.dataset.policyId;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.dataset.policyId);
        tab.dataset.policyTarget = panel.dataset.policyId;
        tab.textContent = panel.dataset.policyName;
        tablist.appendChild(tab);
      });
      nav.appendChild(tablist);
      return nav;
    }

    handleClick(event) {
      var tab = event.target.closest('[role="tab"]');
      if (tab) this.activate(tab.dataset.policyTarget, true, false);
    }

    handleKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      var tabs = Array.from(event.currentTarget.querySelectorAll('[role="tab"]'));
      var index = tabs.indexOf(event.target);
      if (index < 0) return;
      event.preventDefault();
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = tabs.length - 1;
      if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      this.activate(tabs[index].dataset.policyTarget, true, true);
    }

    handleHashChange() {
      var id = decodeURIComponent(window.location.hash.slice(1));
      if (this.panels && this.panels.some(function (panel) { return panel.dataset.policyId === id; })) {
        this.activate(id, false, false);
      }
    }

    activate(id, updateHash, focusTab) {
      var targetPanel = this.panels.find(function (panel) {
        return panel.dataset.policyId === id;
      });
      if (!targetPanel || !this.tablist) return;

      this.getTabs().forEach(function (tab) {
        var active = tab.dataset.policyTarget === id;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.classList.toggle('is-active', active);
        tab.tabIndex = active ? 0 : -1;
      });

      this.updateTabPill();

      targetPanel.hidden = false;
      this.mountNav(targetPanel);
      this.panels.forEach(function (panel) {
        var active = panel.dataset.policyId === id;
        if (!active) panel.hidden = true;
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) panel.setAttribute('aria-labelledby', 'PolicyTab-' + panel.dataset.policyId);
      });

      if (updateHash && window.location.hash !== '#' + id) history.pushState(null, '', '#' + id);
      if (focusTab) {
        var activeTab = this.tablist.querySelector('[data-policy-target="' + id + '"]');
        if (activeTab) activeTab.focus();
      }

      window.requestAnimationFrame(this.updateTabPill.bind(this));
    }
  }

  if (!customElements.get('mt-policy-tabs')) customElements.define('mt-policy-tabs', MtPolicyTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function isBlankNode(el) {
      return !String(el.textContent || '').replace(/\u00a0/g, ' ').trim();
    }

    function normalizeRichtext(box) {
      // Unwrap accidental layout wrappers pasted into richtext (e.g. Basic flex column div).
      Array.prototype.slice.call(box.querySelectorAll('div')).forEach(function (wrap) {
        if (wrap.closest('.mt-product__richtext') !== box) return;
        if (!wrap.querySelector('p, li')) return;
        while (wrap.firstChild) {
          wrap.parentNode.insertBefore(wrap.firstChild, wrap);
        }
        wrap.remove();
      });

      Array.prototype.slice.call(box.querySelectorAll('p')).forEach(function (p) {
        if (!p.querySelector('br')) return;
        var parts = p.innerHTML.split(/<br\s*\/?>/i);
        var created = [];
        parts.forEach(function (part) {
          var html = part.trim();
          if (!html) return;
          var probe = document.createElement('div');
          probe.innerHTML = html;
          if (isBlankNode(probe)) return;
          var next = document.createElement('p');
          next.innerHTML = html;
          created.push(next);
        });
        if (!created.length) {
          p.remove();
          return;
        }
        created.forEach(function (next) {
          p.parentNode.insertBefore(next, p);
        });
        p.remove();
      });

      Array.prototype.slice.call(box.querySelectorAll('p, li')).forEach(function (el) {
        if (isBlankNode(el)) el.remove();
      });
    }

    document.querySelectorAll('.mt-product__richtext').forEach(normalizeRichtext);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-subscribe-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-subscribe-popup')) {
    customElements.define('mt-subscribe-popup', class extends HTMLElement {
      connectedCallback() {
        this.overlay = this.querySelector('[data-sp-overlay]');
        this.dialog = this.querySelector('[data-sp-dialog]');
        this.tab = this.querySelector('[data-sp-tab]');
        this.form = this.querySelector('.mt-subpop__form');
        this.key = this.dataset.key || 'mt-subpop';
        this.designMode = this.dataset.designMode === 'true';

        this.querySelectorAll('[data-sp-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        this.overlay.addEventListener('click', () => this.close());
        this.querySelectorAll('[data-sp-open]').forEach((b) => b.addEventListener('click', () => this.open()));
        var tabClose = this.querySelector('[data-sp-tab-close]');
        if (tabClose) tabClose.addEventListener('click', () => { this.store('session', 'tab-hidden', '1'); this.showTab(false); });
        if (this.form) this.form.addEventListener('submit', (e) => this.submit(e));
        var copy = this.querySelector('[data-sp-copy]');
        if (copy) copy.addEventListener('click', () => this.copyCode(copy));
        var apply = this.querySelector('[data-sp-apply]');
        if (apply) apply.addEventListener('click', (e) => {
          e.preventDefault();
          window.location.href = '/discount/' + apply.dataset.spApply + '?redirect=' + encodeURIComponent(new URL(apply.href, window.location.origin).pathname);
        });

        this.onKey = (e) => {
          if (!this.classList.contains('is-open')) return;
          if (e.key === 'Escape') this.close();
          if (e.key === 'Tab') this.trapFocus(e);
        };
        document.addEventListener('keydown', this.onKey);

        if (this.designMode) {
          this.addEventListener('shopify:section:select', () => this.open());
          this.addEventListener('shopify:section:deselect', () => this.close(true));
          this.showTab(true);
          return;
        }
        this.init();
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        clearTimeout(this.timer);
      }

      store(type, name, value) {
        var area = type === 'session' ? window.sessionStorage : window.localStorage;
        var k = this.key + ':' + name;
        try {
          if (value === undefined) return area.getItem(k);
          if (value === null) area.removeItem(k);
          else area.setItem(k, value);
        } catch (e) { return null; }
      }

      init() {
        if (this.store('session', 'pending') && !/\/challenge/.test(window.location.pathname)) {
          this.store('session', 'pending', null);
          var serverError = this.querySelector('[data-sp-server-error]');
          var posted = this.querySelector('[data-sp-posted]') || /customer_posted=true/.test(window.location.search);
          if (serverError || posted) {
            this.open();
            if (serverError) this.showError(serverError.textContent.trim());
            else this.showSuccess();
            return;
          }
        }
        if (this.store('local', 'subscribed')) return;
        var closedAt = Number(this.store('local', 'closed-at') || 0);
        var days = Number(this.dataset.days || 0);
        var recentlyClosed = closedAt && Date.now() - closedAt < days * 864e5;
        if (recentlyClosed || this.store('session', 'closed')) {
          if (!this.store('session', 'tab-hidden')) this.showTab(true);
          return;
        }
        var delay = Math.max(0, Number(this.dataset.delay || 0)) * 1000;
        this.timer = setTimeout(() => this.autoOpen(), delay);
      }

      autoOpen() {
        var busy = document.querySelector('cart-drawer.is-open') || document.body.style.overflow === 'hidden';
        if (busy) { this.timer = setTimeout(() => this.autoOpen(), 3000); return; }
        this.open();
      }

      showTab(show) {
        if (this.tab) this.tab.hidden = !show;
      }

      open() {
        clearTimeout(this.timer);
        this.lastFocus = document.activeElement;
        this.overlay.hidden = false;
        this.dialog.hidden = false;
        this.showTab(false);
        requestAnimationFrame(() => this.classList.add('is-open'));
        this.prevOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        var input = this.dialog.querySelector('input[type="email"]');
        setTimeout(() => (input && !this.done ? input : this.dialog).focus({ preventScroll: true }), 60);
      }

      close(silent) {
        if (this.dialog.hidden) return;
        this.classList.remove('is-open');
        document.documentElement.style.overflow = this.prevOverflow || '';
        setTimeout(() => { this.overlay.hidden = true; this.dialog.hidden = true; }, 250);
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
        if (silent || this.designMode) { if (this.designMode) this.showTab(true); return; }
        if (this.done) return;
        this.store('local', 'closed-at', String(Date.now()));
        this.store('session', 'closed', '1');
        if (!this.store('session', 'tab-hidden')) this.showTab(true);
      }

      trapFocus(e) {
        var items = Array.from(this.dialog.querySelectorAll('a[href], button, input')).filter((el) => !el.disabled && el.offsetParent !== null);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }

      showSuccess() {
        this.done = true;
        this.store('local', 'subscribed', '1');
        this.showTab(false);
        this.querySelector('[data-sp-step="form"]').hidden = true;
        this.querySelector('[data-sp-step="success"]').hidden = false;
        this.dialog.focus({ preventScroll: true });
      }

      showError(message) {
        var err = this.form && this.form.querySelector('[data-sp-error]');
        if (!err) return;
        err.textContent = message || this.dataset.error || 'Something went wrong. Please try again.';
        err.hidden = false;
      }

      nativeSubmit() {
        this.store('session', 'pending', '1');
        HTMLFormElement.prototype.submit.call(this.form);
      }

      async submit(e) {
        e.preventDefault();
        var btn = this.form.querySelector('[data-sp-submit]');
        this.form.querySelector('[data-sp-error]').hidden = true;
        btn.classList.add('is-loading');
        var res;
        try {
          res = await fetch(this.form.action, { method: 'POST', body: new FormData(this.form), headers: { Accept: 'text/html' } });
        } catch (error) {
          this.nativeSubmit();
          return;
        }
        try {
          // Bot protection (Cloudflare 403 / Shopify /challenge / rate limit) can only be passed by a real page submit.
          if (/\/challenge/.test(res.url) || res.status === 403 || res.status === 429) { this.nativeSubmit(); return; }
          if (/customer_posted=true/.test(res.url)) { this.showSuccess(); return; }
          var html = await res.text();
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var serverError = doc.querySelector('[data-sp-server-error]') || doc.querySelector('form[action*="/contact"] .errors');
          var message = serverError ? serverError.textContent.replace(/\s+/g, ' ').trim() : '';
          if (message) { this.showError(message); return; }
          if (doc.querySelector('[data-sp-posted]')) { this.showSuccess(); return; }
          console.warn('[mt-subscribe-popup] Unexpected response, falling back to page submit:', res.status, res.url);
          this.nativeSubmit();
        } finally {
          btn.classList.remove('is-loading');
        }
      }

      copyCode(btn) {
        var code = this.querySelector('[data-sp-code]').textContent.trim();
        var done = () => { var t = btn.textContent; btn.textContent = btn.dataset.copied || 'Copied'; setTimeout(() => { btn.textContent = t; }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
        else done();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class BgVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { this.load(); this.observer.disconnect(); }
        });
      }, { rootMargin: '200px' });
      this.observer.observe(this);
    }
    load() {
      const src = this.video.getAttribute('data-src');
      if (src && !this.video.src) {
        var host = this;
        var revealed = false;
        var reveal = function () {
          if (!revealed) { revealed = true; host.classList.add('is-playing'); }
        };
        if ('requestVideoFrameCallback' in HTMLVideoElement.prototype) {
          this.video.requestVideoFrameCallback(reveal);
        } else {
          this.video.addEventListener('playing', function () { setTimeout(reveal, 500); }, { once: true });
        }
        this.video.src = src;
        this.video.play().catch(function () {});
      }
    }
  }
  if (!customElements.get('bg-video')) customElements.define('bg-video', BgVideo);

  } catch(e) { console.error(e); }
})();
})();
